import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Trash01 = function Trash01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M16 6v-.8c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C14.4802 2 13.9201 2 12.8 2h-1.6c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C8 3.5198 8 4.08 8 5.2V6m2 5.5v5m4-5v5M3 6h18m-2 0v11.2c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C16.7202 22 15.8802 22 14.2 22H9.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C5 19.7202 5 18.8802 5 17.2V6"
    })
  }));
};
export default Trash01;